var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3497 18.0314L19.5509 19.9165M16.3497 18.0314C14.6238 21.0805 10.8021 22.1251 7.81281 20.3647C4.82348 18.6043 3.79926 14.7054 5.52515 11.6562C7.25104 8.60713 11.0735 7.56243 14.0628 9.32283C17.0521 11.0832 18.0756 14.9822 16.3497 18.0314ZM19.5509 19.9165C20.9229 20.7245 21.7787 22.2075 21.8053 23.8231C21.8177 24.5703 21.9182 25.3 22.0979 26.0002M19.5509 19.9165L23.8767 22.464M16.3497 33.969L19.5509 32.0838M16.3497 33.969C18.0756 37.0181 17.0521 40.9168 14.0628 42.6772C11.0735 44.4376 7.25104 43.3929 5.52515 40.3437C3.79926 37.2946 4.82348 33.3957 7.81281 31.6353C10.8021 29.8749 14.6238 30.9199 16.3497 33.969ZM19.5509 32.0838C20.9229 31.2759 21.7787 29.7929 21.8053 28.1772C21.8177 27.4301 21.9182 26.7004 22.0979 26.0002M19.5509 32.0838L23.8767 29.5364M23.8767 22.464C24.9754 21.1104 26.4564 20.0733 28.1862 19.5336L39.2794 16.0731C40.9596 15.549 42.7504 15.517 44.4476 15.9809L46.1194 16.4378L29.8815 26.0002M23.8767 22.464C23.0458 23.4878 22.4336 24.6926 22.0979 26.0002M29.8815 26.0002L46.1194 35.5626L44.4476 36.0195C42.7504 36.4834 40.9596 36.4514 39.2794 35.9272L28.1862 32.4667C26.4564 31.9271 24.9754 30.89 23.8767 29.5364M29.8815 26.0002L23.8767 29.5364",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarden);
export default __webpack_public_path__ + "static/media/garden.ef00b10d54ff0a2d343acfce68e7560a.svg";
export { ForwardRef as ReactComponent };